import { render } from "./TaskListModal.vue?vue&type=template&id=4bfe6ab7&scoped=true"
import script from "./TaskListModal.js?vue&type=script&lang=js"
export * from "./TaskListModal.js?vue&type=script&lang=js"

import "./TaskListModal.vue?vue&type=style&index=0&id=4bfe6ab7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bfe6ab7"]])

export default __exports__